var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniBar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 3)",
    stroke: "#666"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    y: 2,
    width: 14,
    height: 16,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M2.633 8.422v2.937"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M13.822 0h1.542v4.941h-1.542z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5A2.5 2.5 0 0117 7.5V18h0-5V7.5A2.5 2.5 0 0114.5 5z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17 15a2 2 0 002-2v-2.608h0-4V13a2 2 0 002 2z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.047 15v3"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M14.988 18.024h4.782"
  }))))));
}
export default SvgMiniBar;